import { includes, map, intersection, isEmpty, merge } from "lodash";
import GrErrorReporting from "./gr_error_reporting";

let previouslyRequestedTimestamps;

const reset = () => {
  previouslyRequestedTimestamps = [];
};

reset();

const getDuplicateUpdateIds = (incomingUpdates, updatesAlreadyLoaded) => {
  const incomingIds = map(incomingUpdates, "id");
  const existingIds = map(updatesAlreadyLoaded, "id");
  return intersection(incomingIds, existingIds);
};

export default {


  /**
   * Fetches newsfeed updates for the current user. Due to some circuit breakers
   * built into this, it may not actually make an HTTP request.
   * 
   * @param timestamp - a Number representing a unix timestamp; all updates returned
   *                    should be earlier than this time
   * @param options (optional)
   *        requestParams - an object of additional params to be sent with the request
   *                        e.g. { param1: 3, param2: true }
   *        updatesAlreadyLoaded - newsfeed updates already loaded. Their "id" attributes are
   *                          checked against updates returned by the response and if there
   *                          are duplicates the returned promise is rejected because
   *                          something is wrong with the server output.
   *                          Their structure should be identical to the one used by
   *                          NewsfeedUpdateStore.
   * @returns {jQuery.Deferred Promise} will resolve with the new updates
   *                                    or reject if there is a problem
   */
  loadNewsfeedUpdatesOlderThan(timestamp, options={}) {
    const deferred = $j.Deferred();
    if (includes(previouslyRequestedTimestamps, timestamp)) {
      const error = new Error(`NewsfeedApiClient.loadNewsfeedUpdatesOlderThan called more than once with ${timestamp}`);
      GrErrorReporting.notifyException(error, "NewsfeedApiClient attempted duplicate requests");
      deferred.reject();
      return deferred.promise();
    }

    previouslyRequestedTimestamps.push(timestamp);

    let maxUpdatedAt;
    if (timestamp) {
      maxUpdatedAt = timestamp - 1;
    }

    const updatesAlreadyLoadedCount = options.updatesAlreadyLoaded ? options.updatesAlreadyLoaded.length : 0;
    const requestData = merge({ max_updated_at: maxUpdatedAt, updates_already_loaded_count: updatesAlreadyLoadedCount }, options.requestParams);

    const request = $j.post("/home/load_more_updates", requestData);

    request.done((response) => {
      const duplicates = getDuplicateUpdateIds(response.updates.newsfeedUpdates, options.updatesAlreadyLoaded);
      if (isEmpty(duplicates)) {
        deferred.resolve(response);
      } else {
        const error = new Error(`Request for ${JSON.stringify(requestData)} received duplicate updates: ${JSON.stringify(duplicates)}`);
        GrErrorReporting.notifyException(error, "NewsfeedApiClient received duplicate updates");
        deferred.reject();
      }
    }).fail(deferred.reject);

    return deferred.promise();
  },
  reset,
};
